import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN Navbar variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const navbarVariants = cva(
  'w-full transition-all duration-200 bg-white',
  {
    variants: {
      variant: {
        default: '',
      },
      sticky: {
        true: 'sticky top-0 z-50',
        false: 'relative',
      },
    },
    defaultVariants: {
      variant: 'default',
      sticky: true,
    },
  },
);

export const navbarLinksVariants = cva('flex items-center', {
  variants: {
    orientation: {
      horizontal: 'flex-row gap-10',
      vertical: 'flex-col gap-4 w-full',
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
  },
});

export const navbarActionsVariants = cva('flex items-center gap-2', {
  variants: {
    orientation: {
      horizontal: 'flex-row',
      vertical: 'flex-col w-full mt-4',
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
  },
});

export type NavbarVariantProps = VariantProps<typeof navbarVariants>;
export type NavbarLinksVariantProps = VariantProps<typeof navbarLinksVariants>;
export type NavbarActionsVariantProps = VariantProps<
  typeof navbarActionsVariants
>;
